import React, { useEffect, useState, useRef } from 'react'
import useApp from 'hooks/useApp'
import Lib from 'library'
import { useLocation } from 'react-router-dom'
import { Button, LayerBottom } from 'components'
import styles from './index.module.css'
import Native from 'library/native'

const ThinkPayAfter = () => {

	const App = useApp()
	const location = useLocation();

	const [confirm, setConfirm] = useState(false)
	const [payDataList, setPayDataList] = useState(); // 결제 목록 조회
	const [payProdList, setPayProdList] = useState(); // 결제 상품목록 조회
	const [payDataInfo, setPayDataInfo] = useState(); // 결제정보
	const [prodId, setProdId] = useState(); // 결제상품 ID
	const [endDate, setEndDate] = useState(); // 종료일시

	const mounted = useRef()

	const showLayer = () => {
		setConfirm(true)
	}

	const closeLayer = () => {
		setConfirm(false)
	}

	useEffect(() => {

		mounted.current = true

		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: undefined,
		})

		App.setShowNav(false)
		App.setMainClass("white")

		mounted && getPayList();
		mounted && getProdList();
		mounted && getPayInfo();

		return () => {
			mounted.current = false
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// 결제정보 조회
	const getPayInfo = () => {
		Lib.post("/api/inner/thinkpool/payInfo", data => {
			setPayDataInfo(data);

			setEndDate(() => data.payEndDate.length >= 10 ? data.payEndDate.substring(0, 10).replace(/-/g, ".") : data.payEndDate);
		})
	}

	// 결제목록 조회
	const getPayList = () => {
		Lib.post("/api/inner/thinkpool/mb/prod/pay/list",
			{
				prodId: location.state?.prodId
			}, data => {
				setPayDataList(data);
			})
	}

	// 결제 상품목록 조회
	const getProdList = () => {
		// 상품 목록 조회
		Lib.post("/api/inner/thinkpool/stock/prod/list", data => {
			setPayProdList(data);
		})
	}

	// 구매하기 버튼 클릭시 이동
	const goPay = (prodId) => {
		let receiptNo = "";
		let receiptData = "";
		let payYn = "";

		console.log("구매하기 버튼 네이티브")

		Native.execute("IAP", "productInfo", function (prodResult) {
			console.log("productInfo result", JSON.parse(prodResult).result);
			let prodResultCode = JSON.parse(prodResult).resultCode;
			let prodResultData = JSON.parse(prodResult).result;

			if (prodResultCode !== "0") {
				App.alert(prodResultData);
				return;
			}

			Native.execute("IAP", "purchase", function (result) {
				console.log("purchase result",JSON.parse(result).result)
	
				let resultCode = JSON.parse(result).resultCode;
				let resultData = JSON.parse(result).result;
	
				if (resultCode !== "0") {
					payYn = "N";
					//App.alert(resultData);
					//return;
				} else {
					payYn = "Y";
					receiptNo = resultData.transactionId;
					receiptData = resultData.receiptData;
				}
	
				Lib.post("/api/inner/thinkpool/mb/stock/voucher/pay/save"
					, {
						prodId: prodId,
						receiptNo: receiptNo,
						payYn: payYn,
						resultCode: resultCode,
						receiptData: receiptData
					}
					, data => {
						getPayList();
						getProdList();
						getPayInfo();
					})
	
			}, {
				productId: prodResultData.productId
				// productId: "MY_STOCK_MANAGER"
			})
		},
			{ productId: prodId }
		)
		
		
	}

	// 씽크풀로 이동
	const goThinkPool = (purchasedUrl) => {
		console.log("goThinkPool  thinkpool");
		let url = App.thinkPoolServer + "?mbId=" + window.localStorage.getItem("mbId") + "&fromType=payAfter";

		if (purchasedUrl) {
			url = purchasedUrl + "?mbId=" + window.localStorage.getItem("mbId") + "&fromType=payAfter";
		}
		console.log("url", url);
		Native.execute("Popup", "openPopup", undefined, { url: url, fullscreen: "Y", backPress: "Y" })
		// console.log("App.thinkPoolServer url", url);
		// //window.open(url, '_blank');
		// window.location.href = url;
	}

	return (
		<div className="page">
			<div className="flex_1 padding">
				<div className={styles.title}>상품구매</div>

				<div className={`${styles["prod-use"]} mt_40`}>
					{
						payDataList && payDataList.length > 0 ?
							payDataList.map((item, idx) => {
								return (
									<React.Fragment key={idx}>
										<div>
											<div className={styles["sub-title"]}>현재 이용중인 상품</div>
											<p className="mt_10">{item.prodNm}</p>
											<span className="mt_5">
												{item.useStartDt && item.useStartDt.length >= 10 ? item.useStartDt.substring(0, 10).replace(/-/g, ".") : ""} ~ {item.useEndDt && item.useEndDt.length >= 10 ? item.useEndDt.substring(0, 10).replace(/-/g, ".") : ""}
												{/* {item.useStartDt && item.useStartDt.length>=10 ?item.useStartDt.substring(0,4)+"년"+item.useStartDt.substring(5,7)+"월"+item.useStartDt.substring(8,10)+"일":""} ~ 
												{item.useEndDt && item.useEndDt.length>=10 ?item.useEndDt.substring(0,4)+"년"+item.useEndDt.substring(5,7)+"월"+item.useEndDt.substring(8,10)+"일":""} */}
											</span>
										</div>
										<span className={styles.use}>{item.useState}</span>
									</React.Fragment>
								)
							})
							:
							""
					}

				</div>

				<div className={`${styles["prod-area"]} mt_30`}>
					{
						payProdList ?
							payProdList.map((item, idx) => {
								return (
									<React.Fragment key={idx}>
										<div>
											<p>{item.prodNm}</p>
											<strong className={styles.price}>{Lib.addComma(item.prodAmt)}원</strong>
										</div>
										<span className={styles.btn} onClick={() => {
											if (payDataInfo.payYn === "Y") {
												setProdId(item.prodId);
												showLayer();
											} else {
												goPay(item.prodId)
											}
										}}
										>구매하기</span>
									</React.Fragment>
								)

							})
							:
							""
					}

				</div>

				<div className={`${styles["notice-box"]} mt_30`}>
					<p>안내</p>
					<ul className="mt_10">
						<li>- 모든 결제는 앱스토어를 통해 진행되며, 등록된 결제수단을 이용해 결제가 가능합니다.</li>
						<li>- 모든 상품은 결제와 동시에 서비스 이용이 가능하므로 서비스가 개시된 결제상품에 대해 취소/환불은 어렵습니다.</li>
						<li>- 구매 시점부터 30일 후 23시 59분까지 서비스 이용이 가능하며, 1개월 이후 부터는 새롭게 구매하셔야 프리미엄 콘텐츠를 이용할 수 있습니다.</li>
						<li>- 기타 문의사항을 설정 &gt; 사용자 문의하기를 통해 남겨주시면 최대한 빠른 시일내에 답변해드리겠습니다.</li>
					</ul>
				</div>
			</div>

			<div className="flex-shrink_0 padding">
				{
					location && location.state && location.state.fromGb === "thinkpool" ?
						<Button className="btn btn--big" onClick={() => goThinkPool(location.state?.purchasedUrl)}>메인으로 가기</Button>
						:
						<Button className="btn btn--big" onClick={() => goThinkPool()}>메인으로 가기</Button>
				}

			</div>

			<ConfirmLayer show={confirm} closeLayer={closeLayer} prodId={prodId} endDate={endDate} onPayClick={() => goPay(prodId)} />
		</div>
	)
}

const ConfirmLayer = ({ show, closeLayer, prodId, endDate, onPayClick }) => {
	return (
		<LayerBottom show={show} closeLayer={closeLayer} closeButton={false} outside={
			<div className="flex-align_center">
				<Button className="btn btn--big btn--gray btn-layer" onClick={() => closeLayer()}>아니요</Button>
				<Button className="btn btn--big btn-layer" onClick={() => {
					closeLayer();
					onPayClick(prodId);
				}}>네</Button>
			</div>
		}>
			<div className="layer-text py_10">
				<p>
					이용기간이 아직 남아있습니다.({endDate}) 그래도 추가로 구매하시겠습니까?
					{/* (~2022년 08월 03일) */}

				</p>
				<p className="mt_10">
					추가 구매 시 종료시점 이후로 1개월 자동 연장됩니다.
				</p>
			</div>
		</LayerBottom>
	)
}

export default ThinkPayAfter